<template>
  <v-container fluid>
    <v-card class="mb-6">
      <v-toolbar color="secondary" dark shaped>
        <h3 style="text-transform: uppercase; font-weight: 400">
          {{ $route.name }}
        </h3>
        <v-spacer />
      </v-toolbar>
      <v-card-text>
        <v-row class="mb-6">
          <v-col cols="12">
            <v-autocomplete
              :items="prefectures"
              label="Prefeitura:"
              v-model="filter.prefecture_id"
              item-value="prefecture_id"
              item-text="prefecture_social_name"
            />
          </v-col>
        </v-row>
        <v-footer absolute rounded>
          <v-spacer />
          <v-btn
            color="secondary"
            class="mr-2"
            text
            :to="`/report/veiculos/${filter.prefecture_id}`"
            target="_blank"
            :disabled="filter.prefecture_id ? false : true"
          >
            Gerar Relatório
          </v-btn>
        </v-footer>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  mixins: [Helpers],
  data() {
    return {
      loader: false,
      prefectures: [],
      filter: {
        prefecture_id: null,
      },
    };
  },
  created() {
    this.Helpers;
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    },
  },
};
</script>
